import { DropdownArrow } from "@/styles/partials/icons";
import globals from "../partials/global-variables";
import { NormalText } from "../partials/texts";

const bordersColor = globals.colors.gray5;

export default {
  container: {
    "& .simplebar-offset": {
      width: "calc(100% + 20px)"
    },
    "& .option": {
      position: "relative",
      left: "-10px"
    },
    "& p": {
      ...NormalText,
      textAlign: "center",
      width: "100%",
      fontSize: globals.fontSize.md,
      margin: [0, 0, "70px"],
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: globals.fontSize.lg,
        margin: ["15px", 0, "30px"]
      }
    },
    "& .select-input-wrapper": {
      margin: ["15px", "auto"],
      border: `1px solid ${bordersColor}`,
      maxWidth: "300px",
      width: "100%",
      padding: ["5px", "10px", "5px", 0],
      display: "none"
    },
    "& select": {
      ...NormalText,
      width: "100%",
      background: "transparent",
      border: 0,
      height: "29px",
      padding: "5px",
      outline: 0
    },

    // Custom Dropdown
    "& .custom-select-container.disabled": {
      opacity: 0.5
    },

    "& .custom-select-wrapper": {
      "& .custom-select-container": {
        position: "relative",
        maxWidth: "550px",
        margin: "0 auto",
        "&.is-open": {
          "& .custom-select-answer": {
            "& .icon": {
              transform: "rotate(180deg)"
            }
          },
          "& .custom-select-panel": {
            maxHeight: "177px",
            borderLeft: "1px solid",
            borderRight: "1px solid",
            borderBottom: "1px solid",
            borderColor: bordersColor
          }
        }
      },
      "& .custom-select-answer": {
        ...NormalText,
        display: "block",
        position: "relative",
        marginTop: "50px",
        marginBottom: "50px",
        width: "100%",
        padding: "18px 15px",
        border: "1px solid",
        backgroundColor: "#fff",
        cursor: "pointer",
        textAlign: "center",
        borderColor: bordersColor,
        [`@media (${globals.breakpoints.$xs})`]: {
          marginBottom: "50px"
        },
        "& .icon": {
          ...DropdownArrow
        }
      },
      "& .custom-select-panel": {
        position: "absolute",
        zIndex: "1",
        top: "100%",
        left: 0,
        width: "100%",
        maxHeight: "0",
        transition: "max-height .3s ease-out,overflow-y .1s .5s",
        backgroundColor: "#fff",
        "& .option": {
          ...NormalText,
          cursor: "pointer",
          textAlign: "center",
          padding: "18px 15px",
          borderBottom: "1px solid",
          borderColor: bordersColor,
          "&:last-of-type": {
            borderBottom: "none"
          },
          "&:hover": {
            backgroundColor: globals.colors.blue
          }
        }
      },
      "& .custom-select-panel .option.option-disabled": {
        opacity: 0.5
      }
    },
    ".multi-answer &": {
      "& .custom-select-answer": {
        ...NormalText,
        fontWeight: "normal !important"
      },
      "& .custom-select-panel .option": {
        fontWeight: "normal !important"
      }
    }
  }
};
